module.exports = __webpack_public_path__ + "img/keder_kobaltblau_ral5013.a4d2cf66.jpg";